import {  
    distanceBetweenDots, 
    distanseBetweenLayers, 
    getCenteredCoordinateForAnimation, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot,
    parabolic,
    MINI_BOUNCE_ANIMATION_TIME,
    JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME
 } from '../../initials';
export class JumpFromDotToDotWithMiniBounceTopRightCenter {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'JumpFromDotToDotWithMiniBounceTopRightCenter',
            fromBallPositionByDot: BallPositionByDot.TOP_RIGHT,
            toBallPositionByDot: BallPositionByDot.CENTER,
        };
    }

    getAnimationTime() {
        return MINI_BOUNCE_ANIMATION_TIME + JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;
    }

    animate(time) {

        const isLeftMovement = this.fromDotIndex >= this.toDotIndex;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, Math.PI / 4);
        const endXY = getCenteredCoordinateForAnimation(endDot.dotX, endDot.dotY);

        const firstPartStartX = startXY;

        if (time < MINI_BOUNCE_ANIMATION_TIME) {
            const t = time / MINI_BOUNCE_ANIMATION_TIME;

            return {
                x: parabolic(
                    startXY.x,
                    startXY.x,
                    firstPartStartX.x,
                    t
                ),
                y: parabolic(
                    startXY.y,
                    startXY.y - distanseBetweenLayers / 4,
                    firstPartStartX.y,
                    t
                )
            };
        }

        const t = (time - MINI_BOUNCE_ANIMATION_TIME) / JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;

        return {
            x: parabolic(
                firstPartStartX.x,
                isLeftMovement ? firstPartStartX.x - distanceBetweenDots / 2 : firstPartStartX.x + distanceBetweenDots / 2,
                endXY.x,
                t,
            ),
            y: parabolic(
                firstPartStartX.y,
                startDot.dotY - distanseBetweenLayers,
                endXY.y,
                t,
            )
        };
    }
}